<mat-toolbar>
    <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
        <button class="nav-toggler" mat-icon-button (click)="onToggleSidenav()">
            <mat-icon aria-label="Menu">menu</mat-icon>
        </button>
        <h1 class="page-name">{{ pageTitle | translate }}</h1>
        <ul class="menu-links" *ngIf="!isAuth">
            <li>
                <app-language-selector ></app-language-selector>
            </li>
        </ul>
        <ul class="menu-links" *ngIf="isAuth">
            <!-- <li>
                <a mat-icon-button routerLink="/change-password"><mat-icon aria-label="Account">account_circle</mat-icon></a>
            </li> -->
            <li>
                <button mat-button (click)="onLogout()">
                    <span>{{'main.header.logout.shortLabel' | translate}}</span> <mat-icon aria-label="Exit">exit_to_app</mat-icon>
                </button>
            </li>
        </ul>
    </mat-toolbar-row>
    <mat-toolbar-row class="origin-toolbar" *ngIf="isAuth && origin">
        <ul>
            <li><mat-icon aria-label="city">location_city</mat-icon> {{origin.text?.fullLabel}}</li>
            <li><mat-icon aria-label="tree">account_tree</mat-icon> {{origin.selectedPartitioning?.text?.fullLabel}}</li>
            <li><mat-icon aria-label="calendar">insert_invitation</mat-icon> {{origin.selectedLastYear?.year}} ({{origin.selectedLastYear?.text?.fullLabel}})</li>
            <li *ngIf="selSimuName"><mat-icon aria-label="save">save</mat-icon> {{ selSimuName }}</li>
        </ul>
    </mat-toolbar-row>
</mat-toolbar>
